function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_187995",
  "data-name": "Rectangle 187995",
  width: 21.49,
  height: 21.49,
  transform: "translate(0 0)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_22157",
  "data-name": "Group 22157",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_27570",
  "data-name": "Path 27570",
  d: "M10.745,0A10.745,10.745,0,1,0,21.49,10.745,10.745,10.745,0,0,0,10.745,0M16.73,8.985l-6.653,6.657a1.432,1.432,0,0,1-2.025,0L4.738,12.329a1.431,1.431,0,0,1,2.025-2.022l2.3,2.3L14.7,6.964A1.431,1.431,0,1,1,16.73,8.985"
}));

var SvgCheckmarkCircle = function SvgCheckmarkCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_22158",
    "data-name": "Group 22158",
    width: 21.49,
    height: 21.49,
    viewBox: "0 0 21.49 21.49",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmarkCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Checkmark_Circle.618b143f.svg";
export { ForwardRef as ReactComponent };